export const mangaList = [
  {
    id: 1,
    title: '刃牙道',
    slug: 'baki-dou',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20powerful%20muscular%20martial%20artist%20with%20intense%20expression%2C%20dramatic%20lighting%2C%20red%20and%20black%20color%20scheme%2C%20Japanese%20manga%20aesthetic%2C%20bold%20dynamic%20composition%2C%20action%20pose%2C%20clean%20white%20background%20with%20subtle%20ink%20splatter%20effects%2C%20professional%20manga%20illustration%20quality&width=600&height=840&seq=manga-baki-dou&orientation=portrait',
    category: '格斗',
    author: '板垣恵介',
    status: '连载中',
    rating: 9.5,
    description: '刃牙道的传奇继续！范马刃牙面对前所未有的强敌，在地下竞技场展开惊心动魄的终极对决。',
    updateDate: '2026-08-03',
    latestChapter: '第312话',
    chapters: 312,
    views: 1580000,
  },
  {
    id: 2,
    title: '范马刃牙',
    slug: 'hanma-baki',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20fierce%20young%20fighter%20with%20spiky%20hair%20and%20scarred%20body%2C%20fists%20raised%20in%20fighting%20stance%2C%20dramatic%20red%20and%20dark%20tones%2C%20Japanese%20manga%20art%20style%2C%20bold%20action%20composition%2C%20clean%20neutral%20background%20with%20speed%20lines%2C%20professional%20manga%20illustration&width=600&height=840&seq=manga-hanma-baki&orientation=portrait',
    category: '格斗',
    author: '板垣恵介',
    status: '已完结',
    rating: 9.6,
    description: '范马刃牙追寻最强之路，与父亲范马勇次郎的宿命对决，格斗漫画史上最震撼的父子之战。',
    updateDate: '2026-07-28',
    latestChapter: '第371话（完结）',
    chapters: 371,
    views: 2350000,
  },
  {
    id: 3,
    title: '刃牙',
    slug: 'baki',
    cover: 'https://readdy.ai/api/search-image?query=A%20classic%20manga%20cover%20illustration%20of%20a%20teenage%20fighter%20with%20determined%20eyes%20in%20a%20martial%20arts%20uniform%2C%20retro%20manga%20aesthetic%2C%20warm%20red%20and%20dark%20color%20palette%2C%20Japanese%20fighting%20manga%20style%2C%20dynamic%20stance%2C%20clean%20studio%20background%20with%20subtle%20motion%20lines%2C%20professional%20manga%20quality&width=600&height=840&seq=manga-baki-original&orientation=portrait',
    category: '格斗',
    author: '板垣恵介',
    status: '已完结',
    rating: 9.4,
    description: '刃牙系列的起点！少年范马刃牙踏入地下格斗世界，开始了他成为最强格斗家的旅程。',
    updateDate: '2026-07-25',
    latestChapter: '第421话（完结）',
    chapters: 421,
    views: 3120000,
  },
  {
    id: 4,
    title: '刃牙外传：拳刃',
    slug: 'baki-gaiden',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20mysterious%20masked%20fighter%20with%20wrapped%20hands%2C%20dark%20and%20moody%20atmosphere%2C%20red%20accents%20on%20black%20background%2C%20Japanese%20underground%20fighting%20manga%20style%2C%20intense%20dramatic%20lighting%2C%20professional%20manga%20artwork%2C%20clean%20composition&width=600&height=840&seq=manga-baki-gaiden&orientation=portrait',
    category: '外传',
    author: '板垣恵介',
    status: '连载中',
    rating: 8.9,
    description: '刃牙世界的外传故事，聚焦地下竞技场中其他格斗家的传奇经历与热血战斗。',
    updateDate: '2026-08-01',
    latestChapter: '第87话',
    chapters: 87,
    views: 680000,
  },
  {
    id: 5,
    title: '刃牙II',
    slug: 'baki-2',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20powerful%20muscular%20fighter%20in%20an%20underground%20arena%2C%20crowd%20silhouettes%20in%20background%2C%20dramatic%20spotlight%20effect%2C%20red%20and%20dark%20tones%2C%20Japanese%20fighting%20manga%20aesthetic%2C%20bold%20heroic%20pose%2C%20professional%20manga%20quality&width=600&height=840&seq=manga-baki-2&orientation=portrait',
    category: '格斗',
    author: '板垣恵介',
    status: '已完结',
    rating: 9.3,
    description: '刃牙第二部，最凶死囚篇震撼登场！五位世界级死刑犯来到东京，只为寻求一败。',
    updateDate: '2026-07-20',
    latestChapter: '第312话（完结）',
    chapters: 312,
    views: 1890000,
  },
  {
    id: 6,
    title: '刃牙外传：花山薰',
    slug: 'baki-hanayama',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20large%20yakuza%20style%20fighter%20with%20elaborate%20back%20tattoo%2C%20powerful%20physique%2C%20intense%20stare%2C%20dark%20red%20and%20black%20color%20scheme%2C%20Japanese%20manga%20art%20style%2C%20dramatic%20composition%2C%20clean%20background%2C%20professional%20manga%20quality&width=600&height=840&seq=manga-hanayama&orientation=portrait',
    category: '外传',
    author: '板垣恵介',
    status: '连载中',
    rating: 8.7,
    description: '极道之花——花山薰的独立篇章。被称为日本最强男子的传奇黑道格斗家的热血故事。',
    updateDate: '2026-07-30',
    latestChapter: '第56话',
    chapters: 56,
    views: 420000,
  },
  {
    id: 7,
    title: '刃牙道II',
    slug: 'baki-dou-2',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20legendary%20samurai%20warrior%20in%20modern%20setting%2C%20traditional%20and%20modern%20fusion%2C%20red%20and%20dark%20color%20palette%2C%20Japanese%20manga%20aesthetic%2C%20dynamic%20sword%20pose%2C%20dramatic%20atmosphere%2C%20professional%20manga%20artwork%2C%20clean%20background&width=600&height=840&seq=manga-baki-dou-2&orientation=portrait',
    category: '格斗',
    author: '板垣恵介',
    status: '连载中',
    rating: 9.2,
    description: '宫本武藏复活！战国最强剑豪在现代东京掀起波澜，刃牙世界迎来最大危机。',
    updateDate: '2026-08-03',
    latestChapter: '第198话',
    chapters: 198,
    views: 890000,
  },
  {
    id: 8,
    title: '刃牙外传：烈海王',
    slug: 'baki-retsu',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20Chinese%20martial%20artist%20in%20traditional%20kung%20fu%20stance%2C%20flowing%20robes%2C%20intense%20focused%20expression%2C%20red%20and%20gold%20accents%2C%20Japanese%20manga%20style%2C%20dramatic%20composition%2C%20clean%20neutral%20background%2C%20professional%20manga%20quality&width=600&height=840&seq=manga-retsu&orientation=portrait',
    category: '外传',
    author: '板垣恵介',
    status: '已完结',
    rating: 9.0,
    description: '中国拳法的极致——烈海王的传奇故事。中华武术四千年的精髓在此绽放！',
    updateDate: '2026-07-15',
    latestChapter: '第42话（完结）',
    chapters: 42,
    views: 350000,
  },
  {
    id: 9,
    title: '刃牙特别篇：大擂台赛',
    slug: 'baki-special',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20grand%20tournament%20arena%20scene%20with%20multiple%20fighters%20facing%20off%2C%20epic%20scale%2C%20red%20and%20dark%20tones%2C%20Japanese%20manga%20aesthetic%2C%20cinematic%20composition%2C%20dramatic%20lighting%2C%20professional%20manga%20artwork%2C%20clean%20background&width=600&height=840&seq=manga-baki-special&orientation=portrait',
    category: '特别篇',
    author: '板垣恵介',
    status: '已完结',
    rating: 9.1,
    description: '大擂台赛特别篇！中日两国顶尖格斗家的巅峰对决，百年一度的武术盛典。',
    updateDate: '2026-07-10',
    latestChapter: '全1卷',
    chapters: 1,
    views: 520000,
  },
  {
    id: 10,
    title: '刃牙：相扑道',
    slug: 'baki-sumo',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20massive%20sumo%20wrestler%20in%20traditional%20mawashi%2C%20powerful%20physique%2C%20intense%20face-off%20pose%2C%20red%20and%20dark%20color%20scheme%2C%20Japanese%20manga%20style%2C%20dramatic%20composition%2C%20clean%20background%2C%20professional%20manga%20quality&width=600&height=840&seq=manga-baki-sumo&orientation=portrait',
    category: '特别篇',
    author: '板垣恵介',
    status: '连载中',
    rating: 8.8,
    description: '刃牙系列最新篇章！古代相扑力士苏醒，与现代格斗家的激烈碰撞，力量与技巧的终极考验。',
    updateDate: '2026-08-02',
    latestChapter: '第45话',
    chapters: 45,
    views: 380000,
  },
  {
    id: 11,
    title: '刃牙：少年篇',
    slug: 'baki-youth',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20young%20teenage%20boy%20training%20in%20martial%20arts%2C%20determined%20expression%2C%20morning%20sunlight%2C%20red%20and%20warm%20tones%2C%20Japanese%20manga%20style%2C%20inspiring%20composition%2C%20clean%20neutral%20background%2C%20professional%20manga%20quality&width=600&height=840&seq=manga-baki-youth&orientation=portrait',
    category: '特别篇',
    author: '板垣恵介',
    status: '已完结',
    rating: 8.6,
    description: '刃牙的少年时代！从13岁开始就投身格斗世界的少年范马刃牙，天才的成长之路。',
    updateDate: '2026-07-05',
    latestChapter: '全1卷',
    chapters: 1,
    views: 290000,
  },
  {
    id: 12,
    title: '刃牙外传：愚地独步',
    slug: 'baki-doppo',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20an%20older%20master%20karateka%20with%20weathered%20face%20and%20powerful%20stance%2C%20wisdom%20in%20eyes%2C%20red%20and%20dark%20tones%2C%20Japanese%20manga%20style%2C%20dignified%20composition%2C%20clean%20background%2C%20professional%20manga%20quality&width=600&height=840&seq=manga-doppo&orientation=portrait',
    category: '外传',
    author: '板垣恵介',
    status: '已完结',
    rating: 8.5,
    description: '神心会创始人愚地独步的传奇。空手道之神——被称为「虎」的男人的激斗人生。',
    updateDate: '2026-06-28',
    latestChapter: '全1卷',
    chapters: 1,
    views: 210000,
  },
];

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-grid-line' },
  { slug: 'fighting', name: '格斗', icon: 'ri-boxing-line' },
  { slug: 'gaiden', name: '外传', icon: 'ri-book-open-line' },
  { slug: 'special', name: '特别篇', icon: 'ri-star-line' },
  { slug: 'popular', name: '热门推荐', icon: 'ri-fire-line' },
  { slug: 'completed', name: '已完结', icon: 'ri-check-double-line' },
];

export const latestUpdates = [
  { id: 1, mangaId: 1, mangaTitle: '刃牙道', chapter: '第312话', title: '终极对决', date: '2026-08-03', type: 'regular' },
  { id: 2, mangaId: 7, mangaTitle: '刃牙道II', chapter: '第198话', title: '武藏的决断', date: '2026-08-03', type: 'regular' },
  { id: 3, mangaId: 10, mangaTitle: '刃牙：相扑道', chapter: '第45话', title: '力士的尊严', date: '2026-08-02', type: 'regular' },
  { id: 4, mangaId: 4, mangaTitle: '刃牙外传：拳刃', chapter: '第87话', title: '暗之拳', date: '2026-08-01', type: 'gaiden' },
  { id: 5, mangaId: 6, mangaTitle: '刃牙外传：花山薰', chapter: '第56话', title: '仁义之战', date: '2026-07-30', type: 'gaiden' },
  { id: 6, mangaId: 2, mangaTitle: '范马刃牙', chapter: '第371话', title: '最终话：最强', date: '2026-07-28', type: 'completed' },
  { id: 7, mangaId: 3, mangaTitle: '刃牙', chapter: '第421话', title: '最终话：传承', date: '2026-07-25', type: 'completed' },
  { id: 8, mangaId: 5, mangaTitle: '刃牙II', chapter: '第312话', title: '最终话：死囚的终焉', date: '2026-07-20', type: 'completed' },
  { id: 9, mangaId: 8, mangaTitle: '刃牙外传：烈海王', chapter: '第42话', title: '最终话：拳魂永存', date: '2026-07-15', type: 'completed' },
  { id: 10, mangaId: 9, mangaTitle: '刃牙特别篇：大擂台赛', chapter: '全1卷', title: '大擂台赛', date: '2026-07-10', type: 'special' },
];

export const heroBanners = [
  {
    id: 1,
    title: '刃牙道II - 宮本武蔵篇',
    subtitle: '战国最强剑豪在现代东京苏醒！前所未有的激斗篇章',
    mangaId: 7,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20manga%20style%20battle%20scene%20with%20two%20powerful%20fighters%20clashing%20in%20an%20underground%20arena%2C%20dynamic%20action%20pose%2C%20red%20and%20black%20color%20scheme%2C%20Japanese%20martial%20arts%20atmosphere%2C%20dramatic%20lighting%20with%20spotlight%20effect%2C%20motion%20lines%2C%20epic%20cinematic%20composition%2C%20professional%20illustration%2C%20dark%20background%20with%20crowd%20silhouettes&width=1600&height=700&seq=hero-banner-01&orientation=landscape',
  },
  {
    id: 2,
    title: '范马刃牙 - 父子对决',
    subtitle: '格斗漫画史上最震撼的父子之战，范马刃牙 vs 范马勇次郎',
    mangaId: 2,
    image: 'https://readdy.ai/api/search-image?query=A%20powerful%20manga%20style%20illustration%20of%20father%20and%20son%20facing%20each%20other%20in%20an%20arena%2C%20intense%20staredown%2C%20dramatic%20atmosphere%2C%20red%20and%20dark%20tones%2C%20Japanese%20fighting%20manga%20aesthetic%2C%20epic%20scale%2C%20cinematic%20lighting%2C%20professional%20manga%20artwork&width=1600&height=700&seq=hero-banner-02&orientation=landscape',
  },
  {
    id: 3,
    title: '刃牙：相扑道 - 新章开幕',
    subtitle: '古代相扑力士苏醒！力量与技巧的终极碰撞',
    mangaId: 10,
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20of%20a%20massive%20sumo%20wrestler%20in%20traditional%20attire%20facing%20a%20modern%20fighter%2C%20traditional%20Japanese%20dohyo%20ring%2C%20dramatic%20contrast%2C%20red%20and%20gold%20accents%2C%20Japanese%20manga%20aesthetic%2C%20epic%20composition%2C%20professional%20quality&width=1600&height=700&seq=hero-banner-03&orientation=landscape',
  },
];

export const faqData = [
  {
    question: '刃牙漫画可以在手机上看吗？',
    answer: '当然可以！刃牙漫画免费阅读平台完美适配手机、平板和电脑，下拉式阅读体验让你随时随地畅读刃牙漫画全集。无论使用iOS还是Android设备，都能流畅阅读全部章节。',
  },
  {
    question: '刃牙漫画需要付费吗？',
    answer: '完全免费！刃牙漫画免费全集在线阅读，无需充值、无需注册、无需会员。所有刃牙漫画章节全部免费开放，包括刃牙、范马刃牙、刃牙道等全部系列作品。',
  },
  {
    question: '刃牙漫画的阅读顺序是什么？',
    answer: '刃牙漫画按时间线推荐阅读顺序：刃牙（第一部）→ 刃牙II（最凶死囚篇）→ 范马刃牙（父子对决篇）→ 刃牙道 → 刃牙道II（宫本武藏篇）。外传和特别篇可在任意时间阅读。',
  },
  {
    question: '刃牙漫画更新频率如何？',
    answer: '刃牙漫画连载中的系列通常每周更新一话，汉化版会在原版发布后尽快更新。已完结的系列如刃牙、刃牙II、范马刃牙全部章节均可随时免费阅读。',
  },
  {
    question: '刃牙漫画有哪些外传作品？',
    answer: '刃牙漫画系列拥有丰富的外传作品，包括《拳刃》《花山薰》《烈海王》《愚地独步》等，每个外传都深入刻画了主要角色的精彩故事，同样免费提供阅读。',
  },
];

export const articleData: Record<string, {
  id: number;
  mangaId: number;
  mangaTitle: string;
  chapter: string;
  title: string;
  date: string;
  content: string;
  prevChapter?: { id: number; title: string; };
  nextChapter?: { id: number; title: string; };
}> = {
  '1': {
    id: 1,
    mangaId: 7,
    mangaTitle: '刃牙道II',
    chapter: '第198话',
    title: '武藏的决断',
    date: '2026-08-03',
    content: '宫本武藏站在东京塔顶端，俯瞰着这座现代都市。四百年的时光流转，这个世界已经变得面目全非——高楼林立，铁马川流，人们手中握着发光的方块，终日低头不语。\n\n然而，武藏的心中毫无波澜。\n\n「强者依旧存在。」他低语道，嘴角浮现出一丝笑意。\n\n地下竞技场的欢呼声穿透了混凝土的墙壁，那里聚集着这个时代最强的战士们。武藏从塔顶一跃而下，轻巧地落在街道上。行人们惊讶地回头，却只看到一个模糊的身影消失在暗巷中。\n\n竞技场内，范马刃牙刚刚结束了与一位挑战者的对决。他的身体上布满了新的伤痕，但眼神依然锐利如刀。\n\n「来了吗……」刃牙抬头看向入口处。\n\n武藏缓步走进竞技场，每一步都带着压倒性的气场。在场的所有格斗家都不由自主地屏住了呼吸。\n\n「范马刃牙。」武藏的声音不高，却清晰地传入每个人耳中，「你的拳头，能否斩断我的剑？」\n\n刃牙站起身，活动了一下筋骨：「试试看就知道了。」\n\n两大强者的对决，即将拉开序幕。',
    prevChapter: { id: 197, title: '剑豪降临' },
    nextChapter: { id: 199, title: '拳与剑' },
  },
  '2': {
    id: 2,
    mangaId: 1,
    mangaTitle: '刃牙道',
    chapter: '第312话',
    title: '终极对决',
    date: '2026-08-03',
    content: '擂台上，两位战士对视着。汗水从他们的额头滑落，滴在已经被鲜血染红的地面上。\n\n观众席上鸦雀无声，所有人都屏息凝神，注视着这场注定载入史册的对决。\n\n「你变强了。」对手开口道。\n\n刃牙没有回答，只是调整了自己的呼吸。每一次呼吸都让他的肌肉更加放松，每一块肌肉的松弛都为下一次爆发积蓄着力量。\n\n刹那之间，两人同时动了。\n\n拳头与拳头在空中相撞，产生的冲击波震动了整个竞技场。观众的惊呼声被淹没在这纯粹的力量碰撞之中。\n\n刃牙的脑海中闪过无数画面——父亲的身影、地下竞技场的每一个对手、每一次失败与胜利。这一切汇聚成此刻的一拳。\n\n这一拳，承载着他的全部。',
    prevChapter: { id: 311, title: '最后的前奏' },
    nextChapter: undefined,
  },
  '3': {
    id: 3,
    mangaId: 10,
    mangaTitle: '刃牙：相扑道',
    chapter: '第45话',
    title: '力士的尊严',
    date: '2026-08-02',
    content: '土俵之上，两位力士相对而立。一边是沉睡百年后苏醒的古代横纲，另一边是现代最强的相扑选手。\n\n古代横纲的身躯如同一座小山，每一块肌肉都蕴含着数百年传承的力量。他的呼吸如同风箱，每一次吐纳都让周围的人感受到压迫感。\n\n「相扑——不仅仅是力量的较量。」古代横纲开口，声音低沉如雷鸣，「更是灵魂的对决。」\n\n现代力士深深鞠躬，然后摆出了立ち合い的姿势。他的眼神中没有恐惧，只有对这项古老运动最深沉的敬意。\n\n行司的扇子高高举起，然后猛地挥下。\n\n轰——！\n\n两具庞大的身躯猛烈碰撞，整个土俵都在颤抖。周围的观众感受到了地面的震动，如同地震一般。\n\n古今最强的相扑对决，此刻正式开始。',
    prevChapter: { id: 44, title: '古代力士的挑战' },
    nextChapter: { id: 46, title: '技与力' },
  },
};

export const aboutInfo = {
  brandName: '刃牙漫画',
  brandIntro: '刃牙漫画免费阅读平台致力于为广大刃牙粉丝提供最优质的在线阅读体验。我们收集整理了刃牙系列全部漫画作品，包括《刃牙》《刃牙II》《范马刃牙》《刃牙道》《刃牙道II》等主线作品以及丰富的番外和特别篇章，采用下拉式阅读方式，让读者可以流畅地沉浸在刃牙的热血世界中。',
  mission: '让每一位刃牙粉丝都能免费、便捷地阅读到完整的刃牙系列漫画，感受板垣恵介老师所创造的这个充满力量与信念的格斗世界。',
  features: [
    { title: '完全免费', desc: '刃牙漫画全部章节免费阅读，无需充值，无需会员', icon: 'ri-money-cny-circle-line' },
    { title: '即时更新', desc: '连载章节第一时间更新，紧跟日本原版进度', icon: 'ri-flashlight-line' },
    { title: '高清画质', desc: '所有漫画页面均采用高清扫描，细节清晰可见', icon: 'ri-image-line' },
    { title: '下拉阅读', desc: '流畅的下拉式阅读体验，无需翻页，一气呵成', icon: 'ri-file-list-line' },
    { title: '全平台适配', desc: '手机、平板、电脑完美适配，随时随地畅读刃牙', icon: 'ri-device-line' },
    { title: '社区互动', desc: '与其他刃牙粉丝交流讨论，分享你的阅读感受', icon: 'ri-chat-3-line' },
  ],
  testimonials: [
    { name: '格斗迷小王', text: '追刃牙十年了，终于找到这么全的免费阅读站！画质清晰，更新快，简直是刃牙粉的天堂！', rating: 5 },
    { name: '漫画爱好者小林', text: '下拉式阅读体验太棒了，在公司摸鱼看刃牙不会被发现哈哈。全部免费，良心网站！', rating: 5 },
    { name: '刃牙忠实粉丝', text: '外传和特别篇都有，太全了！花山薰外传在这里找到的，其他地方都没有。强烈推荐！', rating: 5 },
    { name: '板垣老师的信徒', text: '看了十年刃牙，这个网站的阅读体验是最好的。更新速度快，汉化质量高，刃牙粉必收！', rating: 5 },
    { name: '新入坑的小白', text: '朋友推荐刃牙，在这里从第一部开始看起。阅读顺序推荐很贴心，已经停不下来了！', rating: 5 },
    { name: '硬核格斗漫迷', text: '刃牙、拳愿、军鸡都看，但刃牙永远是最爱。这个网站把全部系列都整理好了，太方便了！', rating: 5 },
  ],
  contact: {
    email: 'contact@bakimanga.com',
    wechat: 'bakimanga_official',
    qq: '1234567890',
  },
};